import React from "react"

function WBLabel ({
    className,
    text,
    color = 'black',
    bold = false,
    size = 14
}) {
    return (<div className={`${className} text-${color} text-[${size - 2}px] md:text-[${size}px] ${bold ? 'font-bold' : 'font-normal'}`}>{text}</div>)
}

export { WBLabel }